var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mousemove":_vm.onMouseMove}},[_vm._t("default"),_c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{style:(Object.assign({}, {position: 'fixed',
        top: _vm.cursorY + _vm.offsetY + 'px',
        left: _vm.cursorX + _vm.offsetX + 'px'},
        _vm.tooltipStyle,
        {pointerEvents: 'none',
        zIndex: 1000}))},[_vm._t("tooltip",function(){return [_vm._v("I'm a fancy tooltip")]})],2):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }